<template>
    <div class="applyInvoiceWrap">
        <section class="amountInfo">
            <p v-if="isOldGroup" class="notice">
                滴滴出行券平台服务主体现已由“滴滴出行科技有限公司”变更为“北京桔财动力科技有限公司”。变更前的充值、开票、余额，您可至原先工作台进行查看并使用，或进行退款操作，原工作台的充值余额，继续开具“滴滴出行”发票。即日起充值或开票，均由“桔财动力”提供服务，您可至对应的“桔财动力”后缀的后台进行查看并使用。
            </p>
            <h4 class="fw500">企业支付的发票</h4>
            <p class="title fw500">可开票总额</p>
            <p class="amount fw500">{{canInvoiceAmount}}<span class="fw400">&nbsp;元</span></p>
            <p class="info">累计充值金额 {{rechargeAmount}}元，累计退款金额 {{refundAmount}}元，已开发票 {{invoicedAmount}}元</p>
            <p class="info" v-if="invoiceFlag">免税发票可开票金额 {{canFreeDutyInvoiceAmount}}元，含税发票可开票金额金额 {{canDutyInvoiceAmount}}元</p>
        </section>
        <el-form
            :label-position="'right'"
            :rules="rules"
            ref='invoiceForm' 
            :model="invoiceData" 
            label-width="90px" 
            class="fromWrap">
            <section>
                <h3>开票信息</h3>
                <div class="sectionContent applyAmount">
                    <div v-if="isOldGroup">
                        <el-form-item label="开票类型" required prop="isDutyFree" v-if="invoiceFlag">
                            <el-radio-group v-model="invoiceData.isDutyFree">
                                <el-radio label="1">免税发票</el-radio>
                                <el-radio label="0">含税发票</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-form-item label="开票类型" required prop="isDutyFree" style="display: none;">
                            <el-radio-group v-model="invoiceData.isDutyFree">
                                <el-radio label="0">含税发票</el-radio>
                            </el-radio-group>
                        </el-form-item>    
                    </div>
                    <el-form-item label="开票金额" required prop="applyAmount">
                        <el-input  v-model ="invoiceData.applyAmount" placeholder="请输入开票金额" ></el-input>元
                    </el-form-item>
                </div>
            </section>
            <section>
                <h3>发票信息</h3>
                <div class="sectionContent noBottom">
                    <el-form-item label="发票类型" class="labelTop">
                        <div class="invoiceTypeWrap">
                            <ul v-if="isOldGroup" class="checkImitate invoiceTypeBox">
                                <li  @click="changeInvoiceType(48)" :class="invoiceData.invoiceType == 48 ? 'cur' :''">
                                    <span v-if="invoiceData.isDutyFree == '1'" class="dutyfree">不可抵扣</span>
                                    <span v-else>可抵扣</span>
                                    <p class="fw500">数电普票</p>
                                    <!-- <p>最快5分钟开具</p> -->
                                    <i class="el-icon-check"></i>
                                    <em></em>
                                </li>
                                <li v-if="invoiceData.isDutyFree == '0'"   @click="changeInvoiceType(49)" :class="invoiceData.invoiceType == 49 ? 'cur' :''">
                                    <span class="">可抵扣</span>
                                    <p class="fw500">数电专票</p>
                                    <!-- <p>最快5分钟开具</p> -->
                                    <i class="el-icon-check"></i>
                                    <em></em>
                                </li>
                            </ul>
                            <ul v-else class="checkImitate invoiceTypeBox">
                                <li @click="changeInvoiceType(48)" :class="invoiceData.invoiceType == 48 ? 'cur' :''">
                                    <span  class="dutyfree">不可抵扣</span>
                                    <p class="fw500">数电普票</p>
                                    <!-- <p>最快5分钟开具</p> -->
                                    <i class="el-icon-check"></i>
                                    <em></em>
                                </li>
                                <li  @click="changeInvoiceType(49)" :class="invoiceData.invoiceType == 49 ? 'cur' :''">
                                    <span  class="">可抵扣</span>
                                    <p class="fw500">数电专票</p>
                                    <!-- <p>最快5分钟开具</p> -->
                                    <i class="el-icon-check"></i>
                                    <em></em>
                                </li>
                            </ul>
                            <div v-if="isOldGroup">
                                <p v-if="invoiceData.isDutyFree == '0'" class="warning">*自2019年4月1日起，增值税一般纳税人购进旅客运输服务，电子发票可以抵扣进项税额（疫情期间订单除外）。
                                    <a target="_blank" href="https://wp.xiaojukeji.com/blog/2018/11/21/%E6%97%85%E5%AE%A2%E8%BF%90%E8%BE%93%E6%9C%8D%E5%8A%A1%E8%BF%9B%E9%A1%B9%E7%A8%8E%E9%A2%9D%E4%B8%8D%E5%BE%97%E4%BB%8E%E9%94%80%E9%A1%B9%E7%A8%8E%E9%A2%9D%E4%B8%AD%E6%8A%B5%E6%89%A3/">了解更多</a>
                                </p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="发票抬头" required :class="invoiceTitleList.length>0? 'labelTop':''">
                        <div v-if="invoiceTitleList.length>0" class="invoiceTitleWrap" :class="showTitle?'maxHeight':'minHeight'">
                            <ul class="checkImitate" >
                                <li 
                                    :class="company.id==invoiceData.invoiceQualificationId ?'cur':''" 
                                    @click="choseTitle(company.id)" 
                                    v-for="(company) in invoiceTitleList" 
                                    :key="company.id"
                                >
                                    <p class="title">
                                        {{company.invoiceTitle}}
                                    </p>
                                    <p class="code">
                                        纳税人识别号：{{company.taxRegistrationNumber}}
                                    </p>
                                    <i class="el-icon-check"></i>
                                    <em></em>
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <a target="_blank" href="https://es.xiaojukeji.com/platform/invoice/title">
                                <i class="el-icon-plus"></i>
                                {{ invoiceData.invoiceType == 48 ? '新增普票抬头' :'新增专票抬头' }}
                            </a>
                        </div>
                        <div v-if="invoiceTitleList.length>2">
                            <div v-if="showTitle" @click="showTitle = !showTitle" class="toggleBtn fw500">
                                收起抬头
                                <i class="el-icon-arrow-up"></i>
                            </div>
                            <div v-else @click="showTitle = !showTitle"  class="toggleBtn fw500">
                                展开抬头
                                <i class="el-icon-arrow-down"></i>
                            </div>
                        </div>
                        
                    </el-form-item>
                    <el-form-item label="发票内容" class="invoiceRemark">
                        <div v-if="isOldGroup">
                            *运输服务&nbsp;&nbsp;&nbsp;&nbsp;*客运服务费
                        </div>
                        <div v-else>
                            *信息技术服务&nbsp;&nbsp;&nbsp;&nbsp;*信息技术服务费
                        </div>
                    </el-form-item>
                    <el-form-item label="发票备注" class="labelTop" prop="remark">
                        <el-input v-model="invoiceData.remark" type="textarea" placeholder="将打印在发票的备注上" ></el-input>
                        <span class="case" @click.prevent.stop="showInvoicePic = true">查看示例</span>
                    </el-form-item>
                </div>
            </section>
            <section>
                <h3>收件人信息</h3>
                <div class="sectionContent userInfo">
                    <el-form-item label="邮箱" required prop="email"> 
                        <el-input  v-model="invoiceData.email" placeholder="用于接收电子发票" ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model="invoiceData.phone" ></el-input>
                    </el-form-item>
                </div>
            </section>
        </el-form>
        <div class="bot">
            <el-button type="primary" @click="onApplyInvoice('invoiceForm')"  >开发票</el-button>
        </div>
        <el-dialog
            :visible.sync="showInvoicePic"
            width ="700px"
             title="备注示例"
            custom-class = "dialogWrap"
        >    	
			<div class="imgWrap">
                <img width="560" src="https://es-static.xiaojukeji.com/static/web/kongming/dist_a/images/c0a96bf5.img_fapiao.png" alt="">
            </div>
		    <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.prevent.stop="showInvoicePic = false">已经了解</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import { Message } from 'element-ui'
export default {
    beforeMount: function () {
        if (this.$store.state.header.selfGroup && Object.keys(this.$store.state.header.selfGroup).length > 0) {
            this.$store.dispatch('invoice/getGroupCanInvoiceInfo', {
                groupId: this.$store.state.header.selfGroup.groupId
            })
            this.$store.dispatch('invoice/getInvoiceTitleList', {
                groupId: this.$store.state.header.selfGroup.groupId
            })
            this.$store.dispatch('invoice/getGroupRecentEmail', {
                groupId: this.$store.state.header.selfGroup.groupId
            })
		}
    },
    beforeDestroy:function(){
        // console.log('resetstart')
        this.$store.commit('invoice/resetState')
    },
    data () {
        let checkApplyAmount = (rule, value, callback) => {
            let self = this
            if (isNaN(value) || parseFloat(value).toString() === 'NaN') {
                callback(new Error('开票金额请勿输入除数字及小数点外其他字符'))
                return
            }
            if(!/^(([1-9]\d*)|0)(\.\d{1,2})?$/.test(value)){
                callback(new Error('开票金额请勿输入除数字及小数点外其他字符'))
                return
            }
            if(value <= 0 ){
                callback(new Error('开票金额必须大于0元'))
                return
            }
            if(this.invoiceFlag == false){
                if(Number(value) > Number(self.canDutyInvoiceAmount)){
                    callback(new Error('开票金额不能大于可开票金额'))
                    return
                }
            }
            if(this.invoiceData.isDutyFree == 1 && this.invoiceFlag){
                if(Number(value) > Number(self.canFreeDutyInvoiceAmount)){
                    callback(new Error('开票金额不能大于免税发票可开票金额'))
                    return
                }
            }
            if(this.invoiceData.isDutyFree == 0){
                if(Number(value) > Number(self.canDutyInvoiceAmount)){
                    callback(new Error('开票金额不能大于含税发票可开票金额'))
                    return
                }
            }
            callback()
        }
        return {
            invoiceData:{
                applyAmount:'',
                email:'',
                phone:'',
                invoiceQualificationId:'',
                remark:'',
                isDutyFree:"1",
                invoiceType:48
            },
            showInvoicePic:false,
            showTitle:false,
            rules:{
                applyAmount:[
                    { validator: checkApplyAmount, trigger: 'blur' },
                    { required: true, message: '请输入开票金额', trigger: 'blur' },
                    { required: true, message: '请输入开票金额', trigger: 'change' }
                ],
                remark:[
                    { message: '请填写活动形式', trigger: 'blur' }
                ],
                email:[
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { required: true, message: '请输入邮箱地址', trigger: 'change' },
                    { type:'email',message: '请输入正确的邮箱格式', trigger: 'blur' }
                ],
                phone:[
                    {pattern: /^1[1|3|4|5|6|7|8|9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
                ]
            }
        }
    },
    computed: 
    {
        isOldGroup:function(){
            console.log(this.$store.state.header.selfGroup.version)
            return this.$store.state.header.selfGroup.version == 0 ? true :false
        },
        ...mapState('invoice', {
            canInvoiceAmount:state=> {return (state.canInvoiceAmount).toLocaleString('en-US')},
            canInvoiceAmountLocal:state=> {return state.canInvoiceAmount},
            invoicedAmount:state=> {return (state.invoicedAmount).toLocaleString('en-US')},
            rechargeAmount:state=> {return (state.rechargeAmount).toLocaleString('en-US')},
            refundAmount:state=> {return (state.refundAmount).toLocaleString('en-US')},
            canFreeDutyInvoiceAmount:state=> {return (state.canFreeDutyInvoiceAmount).toLocaleString('en-US')},
            canDutyInvoiceAmount:state=> {return (state.canDutyInvoiceAmount).toLocaleString('en-US')},
            invoiceTitleList:state=> state.invoiceTitleList,
            applyInvoiceSuccess:state=> state.applyInvoiceSuccess,
            invoiceFlag:state => state.invoiceFlag
        })
    },
    methods: {
        onApplyInvoice(Form){
            console.log(this.invoiceData)
            if(this.invoiceData.invoiceQualificationId == ''){
                return Message.error('请选择发票抬头')
            }
            this.$refs[Form].validate((valid) => {
                // console.log('form is right',valid,this.invoiceData)
                
                // return 
                if (valid) {
                    this.$store.dispatch('invoice/applyInvoice', this.invoiceData)
                } else {
                    return Message.error('请完善填写信息')
                }
            });
        },
        choseTitle(id){
            this.invoiceData.invoiceQualificationId = id;
        },
        changeInvoiceType(invoiceType){
            this.invoiceData.invoiceType = invoiceType;
        }
    },
    mounted(){
        if(this.invoiceFlag == false){
            this.invoiceData.isDutyFree = "0"
        }else{
            console.log(111)
            this.invoiceData.isDutyFree = "1"
        }   
    },
    watch: {
        '$store.state.invoice.lastPhone':function(val){
            if(this.invoiceData.phone == ''){
                this.invoiceData.phone = val
            }
        },
        '$store.state.invoice.lastEmail':function(val){
            if(this.invoiceData.email == ''){
                this.invoiceData.email = val
            }
        },
        '$store.state.invoice.invoiceTitleList':function(val,oldVal){
            if(val.length >0){
                this.invoiceData.invoiceQualificationId = val[0].id
            }
        },
        '$store.state.invoice.invoiceFlag':function(val,oldVal){
            if(val){
                this.invoiceData.isDutyFree = "1"
            }else{
                this.invoiceData.isDutyFree = "0"
            }
        },
        'invoiceData.isDutyFree':function(val,oldVal){
            this.invoiceData.invoiceType = 48
        },
        'invoiceData.invoiceType':function(val,oldVal){
            if(val !== oldVal){
                this.$store.commit('invoice/resetInvoiceTitleList')
                let params = {
                    groupId: this.$store.state.header.selfGroup.groupId
                }
                if(val == 49){
                    params = Object.assign({},params,{
                        invoiceType:49
                    })
                }
                this.$store.dispatch('invoice/getInvoiceTitleList', params)
            }
        },
        applyInvoiceSuccess:function(isSucc){
            if(isSucc){
                // this.$store.commit('invoice/applyInvoiceSuccess', {res: false})
                Message({
                    message: '开票成功',
                    type: 'success',
                    duration: '1000',
                    onClose: function () {
                        window.location.reload()
                    }
                })
            }else{
                return Message.error('开票失败')
            }
        }
    }
}
</script>
<style lang="stylus">
    .fw500
        font-weight 500
    .fw400
        font-weight 400
    .applyInvoiceWrap
        
        .amountInfo
            padding 30px 0 40px 40px
            color #333
            font-size 14px
            h4
                font-size  16px
                padding-bottom 30px
            .title
                padding-bottom 10px
                background url('../../images/ic_money1.png') no-repeat
                background-size 16px 16px
                background-position 0px 2px
                padding-left 21px
            .amount
                font-size 40px
                font-family 'DIN-Medium'
                span 
                    font-size 14px
            .notice
                background #cad7fb
                font-size 12px
                padding 10px
                opacity 0.9
                margin-bottom 10px
                a
                    color: rgb(52, 104, 255)
                    text-decoration none    
        h3
            height 50px
            line-height 50px
            background #F3F4F5 
            font-size 16px
            color #666666
            padding-left 20px
            margin 0
            font-weight 500
        .fromWrap
            padding  0 20px    
            .el-form-item__label
                padding-right 20px
                font-weight 500
            .el-input__inner,.el-textarea__inner
                border-radius 0
                border 1px solid #ccc
            .el-input__inner
                height 34px
                padding 0 10px 
            .sectionContent
                padding 30px 20px 40px
            .applyAmount
                .el-form-item
                    margin 0
                .el-input
                    width 135px
                    margin-right 10px
            .userInfo
                .el-form-item
                    margin-bottom 30px
                .el-input
                    width 320px
            .invoiceTypeWrap 
                ul 
                    li
                        position relative
                        height 100px
                        width 200px
                        border 1px solid #ccc
                        text-align center
                        color #3468FF
                        display flex
                        align-items center
                        flex-direction column
                        justify-content center
                        span 
                            display inline-block
                            position absolute
                            height 20px
                            line-height 20px
                            width 48px
                            background #2EAC46
                            color #fff
                            font-size 12px
                            right -1px
                            top -1px
                            border-bottom-left-radius 4px 
                        span.dutyfree
                            background #999999
                            width 60px
                        p
                            font-size 14px  
                            height 20px
                            line-height 20px
                        p:first-of-type
                            font-size 18px
                            height 25px
                            line-height 25px
                .warning
                    color #FC6F53 
                    height 24px
                    line-height 24px
                    margin-top 10px    
            .checkImitate
                li
                    position relative
                    overflow hidden
                    em
                        position absolute
                        right -30px
                        bottom -30px
                        width 0
                        height 0
                        z-index 10
                        border-style solid
                        border-width 0 0 24px 24px
                        border-color transparent transparent #3467ff transparent
                    i 
                        position absolute
                        right -30px
                        bottom -30px
                        font-size 12px
                        color #fff
                        z-index 11
                        font-weight 600
                .cur
                    border 1px solid #3468FF
                    em
                        right 0
                        bottom 0
                    i  
                        right 1px
                        bottom 1px
            .invoiceTypeBox
                display flex
                li
                    margin-right 10px
            .invoiceTitleWrap
                width 646px
                overflow auto
                li
                    width 580px
                    padding 10px 20px
                    margin-bottom 10px
                    border 1px solid #CCCCCC
                    position relative
                    cursor pointer
                    .title
                        height 20px
                        line-height 20px
                        font-size 14px
                        color #666666
                        font-weight 500
                    .code
                        height 18px
                        line-height 18px
                        font-size 13px
                        color #999999
                .cur
                    em
                        border-width 0 0 20px 20px
                    i  
                        right 0 
                        bottom 0
                    .title
                        color #333333
                    .code    
                        color #666666
                    
            .toggleBtn
                font-size 14px
                color #3468FF
                height 20px
                line-height 20px
                padding-top 10px
                cursor pointer
                i 
                    font-weight 600
            .noBottom
                .el-form-item
                    margin-bottom 30px
                .el-form-item:last-of-type
                    margin-bottom 0
            .maxHeight
                height 226px
            .minHeight
                height 100px
            
            .invoiceRemark
                color #333
                .el-form-item__label,.el-form-item__content
                    height 20px
                    line-height 20px
            .el-textarea
                width 620px
                textarea
                    height 100px
            .case
                color #3468FF
                height 20px
                line-height 20px
                margin-top 10px
                cursor pointer
                display block
                width 60px
            a
                color #3468FF
                text-decoration none              
            .labelTop
                .el-form-item__label
                    line-height 20px
        .bot
            padding-top 16px
            background-color #fff
            z-index 100
            padding-left 120px
            box-shadow 0 -5px 15px 0 hsla(0,1%,65%,.15)
            position fixed
            bottom 0
            width 100%
            height 64px
.dialogWrap
    .imgWrap
        img
            display block
            margin  0 auto
</style>
